import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, Card, Grid, Dropdown, Icon} from 'semantic-ui-react';
import {hasAccessPermission} from '../../common/permissions/validations';
import {resources, scopes} from '../../common/permissions/dictionary';
import {paths} from '../../common/dictionaries/urls';
import {warehouses} from '../../common/dictionaries/parameters';
import {
  buildUniqueCodeFromAgencyObj,
  getAgencyFromUniqueCodeStr,
} from '../../picking/components/scanning/common/utils';
import {Actions} from '../../common/actions';
import PendingItemsTable from './pendingItemsTable';
import ConfirmationModal from './modal/confirmation';

class LubricantsInvoicing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'agencyTmp': '',
      'agencySelected': '',
    };

    this.onAgencyDropdownChange = this.onAgencyDropdownChange.bind(this);
    this.onAgencyUpdate = this.onAgencyUpdate.bind(this);
    this.onRefreshClick = this.onRefreshClick.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.LubricantsInvoicing,
        scopes.Create
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
      return;
    }
    this.props.clearLubricantsInfo();
    this.props.fetchAgenciesList({'warehouse': warehouses.lubricants});
  }

  getAgencyDropdownOptions() {
    const {agencies} = this.props;

    return agencies.map((agency) => {
      return {
        'text': `${agency.dealerName} - ${agency.name}`,
        'value': buildUniqueCodeFromAgencyObj(agency),
      };
    });
  }

  onAgencyDropdownChange(event, {value}) {
    this.setState({'agencyTmp': value}, () => this.onAgencyUpdate());
  }

  onAgencyUpdate() {
    const {agencySelected, agencyTmp} = this.state;
    if (agencySelected === agencyTmp) {
      return;
    }

    this.setState(
      {
        'agencySelected': agencyTmp,
      },
      () => {
        this.fetchItems();
      }
    );
  }

  fetchItems() {
    const {agencies} = this.props;
    const {agencySelected} = this.state;
    const agency = getAgencyFromUniqueCodeStr(agencies, agencySelected);
    this.props.fetchScanningPendingItemsList(agency, warehouses.lubricants);
  }

  onRefreshClick() {
    this.setState({
      'agencyTmp': '',
      'agencySelected': '',
    });

    this.props.clearLubricantsInfo();
    this.props.fetchAgenciesList({'warehouse': warehouses.lubricants});
  }

  renderInvoiceButton() {
    const {loadingAgencies, processingInvoice, agencies, sequencesMarked} =
      this.props;
    const {agencySelected} = this.state;

    if (!agencySelected || !sequencesMarked.length) {
      return (
        <Button
          primary
          className='toyota-primary'
          disabled={
            loadingAgencies || !sequencesMarked.length || processingInvoice
          }
          loading={processingInvoice}
        >
          Facturar
        </Button>
      );
    }

    const agency = getAgencyFromUniqueCodeStr(agencies, agencySelected);
    return <ConfirmationModal agency={agency} sequences={sequencesMarked} />;
  }

  render() {
    const {loadingAgencies, processingInvoice} = this.props;
    const {agencyTmp, agencySelected} = this.state;

    return (
      <div className='lubricants-invoicing-page'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Facturación de Lubricantes</h2>
              <div className='title-bar-actions'>
                {this.renderInvoiceButton()}
              </div>
            </div>
            <div className='filters-section'>
              <Grid textAlign='left'>
                <Grid.Row>
                  <Grid.Column width={1}>
                    <h4>Agencia</h4>
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Dropdown
                      value={agencyTmp}
                      options={this.getAgencyDropdownOptions()}
                      selection
                      search
                      loading={loadingAgencies}
                      disabled={loadingAgencies || processingInvoice}
                      noResultsMessage='Agencia no encontrada'
                      onChange={this.onAgencyDropdownChange}
                    />
                  </Grid.Column>
                  <Grid.Column width={1}>
                    <Button
                      primary
                      loading={loadingAgencies}
                      disabled={loadingAgencies || processingInvoice}
                      className='toyota-primary refresh'
                      onClick={this.onRefreshClick}
                    >
                      <Icon name='refresh' size='large' />
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>
        {agencySelected !== '' && (
          <Card raised fluid>
            <PendingItemsTable />
          </Card>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'processingInvoice': state.lubricantsInvoicing.creatingInvoice,
    'loadingAgencies': state.lubricantsInvoicing.loadingAgenciesList,
    'agencies': state.lubricantsInvoicing.agenciesList,
    'sequencesMarked': state.lubricantsInvoicing.sequencesMarked,
    'permissions': state.session.permissions,
  };
};

const {
  clearLubricantsInfo,
  fetchAgenciesList,
  fetchScanningPendingItemsList,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  clearLubricantsInfo,
  fetchAgenciesList,
  fetchScanningPendingItemsList,
  navigateTo,
})(LubricantsInvoicing);
